(function() {
  'use strict';

  var SUPABASE_URL = 'https://tbzlhewcevuyopsytcwi.supabase.co';
  var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRiemxoZXdjZXZ1eW9wc3l0Y3dpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzMTA3MzIsImV4cCI6MjA5NDg4NjczMn0.AgZa1dXiowhgqMlCOSN9EuUpYOkDCitCmvUxsk3C6OA';
  var STORAGE_SIGNED = 'gm-sms-signed-up';
  var STORAGE_SEEN = 'gm-sms-popup-seen';

  function hasSession() {
    try {
      var raw = localStorage.getItem('gm_session');
      if (!raw) return false;
      var session = JSON.parse(raw);
      return !!(session && (session.access_token || session.refresh_token));
    } catch (e) {
      return false;
    }
  }

  function storageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function storageSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* ignore */ }
  }

  function setStatus(el, message, kind) {
    if (!el) return;
    if (el.__gmSmsStatusTimer) {
      window.clearTimeout(el.__gmSmsStatusTimer);
      el.__gmSmsStatusTimer = null;
    }
    el.textContent = message || '';
    el.classList.remove('is-error', 'is-ok');
    if (kind) el.classList.add(kind);
    if (!message) return;
    el.__gmSmsStatusTimer = window.setTimeout(function() {
      el.textContent = '';
      el.classList.remove('is-error', 'is-ok');
      el.__gmSmsStatusTimer = null;
    }, 5000);
  }

  function closePopup(popup, markSeen) {
    if (!popup) return;
    popup.classList.remove('is-open');
    document.body.classList.remove('gm-sms-popup-open');
    window.setTimeout(function() {
      popup.hidden = true;
    }, 280);
    if (markSeen) storageSet(STORAGE_SEEN, '1');
  }

  function openPopup(popup) {
    if (!popup) return;
    popup.hidden = false;
    // force reflow before open class
    void popup.offsetWidth;
    popup.classList.add('is-open');
    document.body.classList.add('gm-sms-popup-open');
    var phone = popup.querySelector('[name="phone"]');
    if (phone) {
      window.setTimeout(function() { phone.focus(); }, 320);
    }
  }

  function bindForm(root, onSuccess) {
    if (!root || root.__gmSmsBound) return;
    root.__gmSmsBound = true;

    var form = root.querySelector('[data-gm-sms-form]');
    if (!form) return;

    var phoneInput = form.querySelector('[name="phone"]');
    var consentInput = form.querySelector('[name="consent"]');
    var hpInput = form.querySelector('[name="company"]');
    var submitBtn = form.querySelector('[data-gm-sms-submit]');
    var statusEl = root.querySelector('[data-gm-sms-status]');
    var source = root.getAttribute('data-source') || 'footer';

    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      var phone = phoneInput ? phoneInput.value.trim() : '';
      var consent = !!(consentInput && consentInput.checked);
      var honey = hpInput ? hpInput.value.trim() : '';

      if (!phone) {
        setStatus(statusEl, 'enter your phone number', 'is-error');
        if (phoneInput) phoneInput.focus();
        return;
      }
      if (!consent) {
        setStatus(statusEl, 'check the box to get text reminders', 'is-error');
        if (consentInput) consentInput.focus();
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is-busy');
        submitBtn.textContent = '…';
      }
      setStatus(statusEl, 'signing you up…', null);

      try {
        var res = await fetch(SUPABASE_URL + '/functions/v1/guest-sms-subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            apikey: SUPABASE_ANON_KEY,
            Authorization: 'Bearer ' + SUPABASE_ANON_KEY
          },
          body: JSON.stringify({
            phone: phone,
            consent: true,
            company: honey,
            source: source
          })
        });
        var data = null;
        try { data = await res.json(); } catch (err) { data = null; }

        if (!res.ok || !data || !data.ok) {
          setStatus(statusEl, (data && data.error) || 'could not sign up — try again', 'is-error');
          return;
        }

        if (data.sms_skipped) {
          setStatus(statusEl, 'saved — finish klaviyo sms setup for texts', 'is-ok');
        } else {
          setStatus(statusEl, 'you’re on the list for text reminders', 'is-ok');
        }
        form.reset();
        storageSet(STORAGE_SIGNED, '1');
        storageSet(STORAGE_SEEN, '1');
        if (typeof onSuccess === 'function') onSuccess();
      } catch (err) {
        setStatus(statusEl, 'network error — try again', 'is-error');
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-busy');
          submitBtn.textContent = 'notify me';
        }
      }
    });
  }

  function shouldShowPopup() {
    if (storageGet(STORAGE_SIGNED) === '1') return false;
    if (storageGet(STORAGE_SEEN) === '1') return false;
    if (hasSession()) return false;
    return true;
  }

  function initPopup() {
    var popup = document.querySelector('[data-gm-sms-popup]');
    if (!popup) return;

    var signup = popup.querySelector('[data-gm-sms-signup]');
    bindForm(signup, function() {
      window.setTimeout(function() {
        closePopup(popup, true);
      }, 1200);
    });

    popup.querySelectorAll('[data-gm-sms-popup-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        closePopup(popup, true);
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      if (!popup.classList.contains('is-open')) return;
      closePopup(popup, true);
    });

    if (!shouldShowPopup()) return;

    window.setTimeout(function() {
      if (!shouldShowPopup()) return;
      openPopup(popup);
    }, 1100);
  }

  function initInline() {
    document.querySelectorAll('[data-gm-sms-signup]').forEach(function(root) {
      if (root.closest('[data-gm-sms-popup]')) return;
      try {
        if (storageGet(STORAGE_SIGNED) === '1' && !hasSession()) {
          root.hidden = true;
          return;
        }
      } catch (e) { /* ignore */ }
      bindForm(root);
    });
  }

  function init() {
    initInline();
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
